import * as React from "react";
import classnames from "classnames";
import { MediaQuery, Card } from "@grandvisionhq/common";
import { placeholderImage } from "@grandvisionhq/utils";
/* empty css                            */
const ConfirmationReturnItem = ({ item }) => {
  const { displayName, imageSrc } = item;
  const { useIsPhone } = MediaQuery;
  const isPhone = useIsPhone();
  return /* @__PURE__ */ React.createElement(Card, { layout: isPhone ? "vertical" : "horizontal", className: "confirmation-return-item" }, /* @__PURE__ */ React.createElement(
    Card.Content,
    {
      childrenWrapperClassName: "confirmation-return-item__top-container",
      className: "confirmation-return-item__card-content--top"
    },
    /* @__PURE__ */ React.createElement("div", { className: "confirmation-return-item__image-container" }, /* @__PURE__ */ React.createElement(
      "img",
      {
        alt: displayName || "",
        src: imageSrc || placeholderImage.url,
        className: classnames("confirmation-return-item__image", {
          "confirmation-return-item__image--placeholder": !imageSrc
        })
      }
    )),
    /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Card.Heading, { className: "confirmation-return-item__heading", component: "h2" }, displayName))
  ));
};
export {
  ConfirmationReturnItem as default
};
//# sourceMappingURL=ConfirmationReturnItem.js.map
